import React from "react"
import TnCText from "./TnCText"
import defaultTnC from "../assets/TnCText.txt"

function TnCModal({ visible, closeModal, textFile = defaultTnC }) {
  return (
    // MODAL VIEW
    <div
      className={
        visible
          ? "modal-view modal-view-visible"
          : "modal-view modal-view-hidden"
      }
    >
      {/* MODAL */}
      <div
        className={visible ? "modal modal-slide-up" : "modal modal-slide-down"}
      >
        <div className="modal-title">
          <h1>Terms and Conditions</h1>
        </div>
        <div className="modal-container">
          <TnCText textFile={textFile} />
        </div>
        <div className="modal-footer">
          <button type="button" className="modal-done-btn" onClick={closeModal}>
            Done
          </button>
        </div>
      </div>
    </div>
  )
}

export default TnCModal
